module.exports = __webpack_public_path__ + "img/login_title.fcca4ede.png";